/**
 * 저장소 자리의 소유자 — 정본 하나(D-121).
 *
 * 서버(BFF 저장소)는 객체 키의 첫 조각이 호출자일 때만 받는다(`object_scope` — 키는 `<사용자>/<프로젝트>/…`). 그래서 자리의 소유자는
 * 로그인한 사용자이고, 프로젝트의 자리는 그 프로젝트의 주인이 호출자일 때만 쓴다. 모르면(로그인 정보·프로젝트의 주인이 없음) 자리를 짐작하지 않고,
 * 하려던 일을 한 문장으로 거절한다 — 시작·재시작 좌표·편집기 검증·FMU 해석·카드 폴더 정리·모델 폴더 지우기·이어보기가 이것을 쓴다.
 * 이 모듈은 순수하다(로그인 상태를 들이지 않는다 — 노드 환경의 저작 모듈이 쓴다). 로그인한 사용자로 판정하는 것은 `signedInStorageOwner`.
 * 전에는 자리마다 소유자를 따로 셈하고(프로젝트의 `user_id` 또는 로그인 사용자) 거절 문장을 복사하거나 조용히 건너뛰었다.
 */
export type StorageOwner = { ok: true; userId: string } | { ok: false; reason: string };

/**
 * 순수 판정 — `callerId` 는 로그인한 사용자, `action` 은 하려던 일(«시작할»·«FMU 를 해석할» — 뒤에 «수 없습니다» 가 붙는다),
 * `project` 를 주면 그 프로젝트의 자리를 쓰는 일이다(주인이 호출자여야 한다).
 */
export function storageOwnerOf(
  callerId: string | null | undefined,
  action: string,
  project?: { user_id?: string | null } | null,
): StorageOwner {
  const caller = (callerId ?? '').trim();
  if (!caller) return { ok: false, reason: `사용자 정보가 없어 ${action} 수 없습니다 — 다시 로그인해 주세요` };
  if (project) {
    const projectOwner = (project.user_id ?? '').trim();
    // 주인을 모르는 것과 남의 것은 다른 사실이다 — 모르는 것을 «남의 것» 이라 말하지 않는다
    if (!projectOwner) return { ok: false, reason: `이 프로젝트의 주인을 알 수 없어 ${action} 수 없습니다 — 프로젝트를 다시 열어 주세요` };
    if (projectOwner !== caller) return { ok: false, reason: `이 프로젝트의 주인이 아니라 ${action} 수 없습니다 — 저장소의 자리는 프로젝트 주인의 것입니다` };
  }
  return { ok: true, userId: caller };
}
